import Button from "../../../components/common/button";
import { HusmodellerTable } from "./HusmodellerTable";
import { useAuthData } from "../../../context/AuthContext";

export const Husmodeller = () => {
  const { adminData } = useAuthData();

  const canAdd = () => {
    if (!adminData) return false;

    if (
      adminData.role === "Admin" ||
      adminData.email === "andre.finger@gmail.com"
    ) {
      return true;
    }

    const husmodellPermission = adminData.modulePermissions?.find(
      (item: any) => item.name === "Husmodell"
    );

    return husmodellPermission?.permissions?.add || false;
  };

  return (
    <>
      <div className="px-4 md:px-6 pt-6 pb-16 flex flex-col gap-4 md:gap-6">
        <div className="flex items-center justify-between">
          <h1 className="text-darkBlack font-medium text-xl md:text-2xl desktop:text-[30px]">
            Alle hus- og hyttemodeller
          </h1>
          {canAdd() && (
            <Button
              text="Legg til ny modell"
              className="border border-primary bg-primary text-white text-sm rounded-[8px] h-[40px] font-medium relative px-4 py-[10px] flex items-center gap-2"
              path="/add-husmodell"
            />
          )}
        </div>
        <HusmodellerTable />
      </div>
    </>
  );
};
